<template>
  <div class="main-page">
    <Header />
    <main>
      <intro />
      <coverse />
      <for-whom />
      <comparisons />
      <how-it-work />
    </main>
    <div class="main-page-footer">
      <Footer />
    </div>
  </div>
</template>

<script>

import Header from "@/components/partials/Header.vue";
import Footer from "@/components/partials/Footer.vue";
import Intro from "@/components/main/partials/Intro.vue";
import Coverse from "@/components/main/partials/Coverse";
import ForWhom from "@/components/main/partials/ForWhom";
import Comparisons from "@/components/main/partials/Comparisons";
import HowItWork from "@/components/main/partials/HowItWork";

export default {
  name: 'Main',
  components: {
    Intro,
    Coverse,
    ForWhom,
    Comparisons,
    HowItWork,
    Header,
    Footer,
  },
}
</script>

<style scoped lang="scss">
@import "@/styles/breakpoints";

@include media-breakpoint-down($size-tablet) {
  .main-page-footer {
    &:deep(footer) {
      .wrapper {
        padding-left: 30px;
        padding-right: 30px;
        padding-top: 35px;

        .content {
          .links {
            margin-top: 10px;
          }
        }
      }
    }
  }
}

@include media-breakpoint-down($size-mobile) {
  main {
    padding-top: 60px;
  }

  .main-page-footer {
    &:deep(footer) {
      .wrapper {
        padding-left: 20px;
        padding-right: 20px;
      }
    }
  }

  .main-page {
    overflow: hidden;
  }
}
</style>
